import http from './http-common';

class CommonService {
    delete(userId, securityItemName, tableName, primaryKeyFieldName, primaryKeyFieldValue, IsDeleted) {
        return http.get(`/delete/${userId}/${securityItemName}/${tableName}/${primaryKeyFieldName}/${primaryKeyFieldValue}/${IsDeleted}`);
    }
}

export default new CommonService();